import type { Icon } from '@/components/Base/Lucide/icon.types';
import { defineStore } from 'pinia';

export interface Menu {
  icon: Icon;
  title: string;
  badge?: number;
  pageName?: string;
  subMenu?: Menu[];
  ignore?: boolean;
}

export interface MenuState {
  value: Array<Menu | string>;
}

export const useMenuStore = defineStore('menu', {
  state: (): MenuState => ({
    value: [
      'DASHBOARD',
      {
        icon: 'GanttChartSquare',
        pageName: 'invoices',
        title: 'Invoices',
        badge: 4,
      },
      {
        icon: 'Users',
        pageName: 'users',
        title: 'Users',
        badge: 4,
      } as Menu,
    ],
  }),
});
